module.exports = __webpack_public_path__ + "images/marketing/peeps/chen_li.png";